module.exports = __webpack_public_path__ + "SPACEC6P.b17da6481ad2595db407.svg";


//////////////////
// WEBPACK FOOTER
// /Users/Guest/Desktop/Space-Janitor/src/assets/fonts/SPACEC6P.svg
// module id = ../../../../../src/assets/fonts/SPACEC6P.svg
// module chunks = main